import { Button, Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ApresentacaoClarea = () => {
    const navigate = useNavigate();

    // Carregar script do Calendly

    //     <!-- Calendly inline widget begin -->
    // <div class="calendly-inline-widget" data-url="https://calendly.com/personal-contblack/primeiros-passos-contblack-clone?text_color=11305e&primary_color=dcca30" style="min-width:320px;height:700px;"></div>
    // <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script>
    // <!-- Calendly inline widget end -->
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://assets.calendly.com/assets/external/widget.js";
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <>
            <Box
                sx={{
                    width: "100%",
                    height: "fit-content",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: 2,
                    gap: 4
                }}
            >
                <Box sx={{ width: "60%", maxWidth: 900, textAlign: "center" }}>
                    <Typography variant="h4" fontWeight="bold" gutterBottom>
                        Apresentação Clarea Vital
                    </Typography>
                    <Typography variant="body1" mb={4}>
                        Bem-vindo à página de apresentação da Clarea Vital.
                    </Typography>
                    {/* Container responsivo do vídeo */}
                    <Box
                        sx={{
                            position: "relative",
                            paddingBottom: "56.25%", // 16:9
                            height: 0,
                            overflow: "hidden",
                            borderRadius: 2,
                            mb: 4,
                            boxShadow: 3
                        }}
                    >
                        <iframe
                            src="/assets/VideoApresentacao.mp4"
                            title="Apresentação Clarea Vital"
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%"
                            }}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </Box>
                </Box>
            </Box>
            {/* Calendly Widget */}
            <div style={{ textAlign: "center", width: "100%" }}>
                <h2>Agende uma reunião conosco</h2>
                <p>Escolha o dia e horário que seja conveniente para você.</p>
            </div>
            <div
                className="calendly-inline-widget"
                data-url="https://calendly.com/personal-contblack/primeiros-passos-contblack-clone?text_color=11305e&primary_color=dcca30"
                style={{ minWidth: "320px", height: "700px", marginTop: "0px", paddingTop: "0px" }}
            ></div>
            <div style={{ width: "100%", justifyContent: "center", display: "flex", marginBottom: "40px", flexDirection: "column", alignItems: "center" }}>
                <Typography variant="body1" mb={1}>
                    Você pode clicar no botão abaixo para acessar a plataforma <b>Clarea Vital</b>
                </Typography>
                <Button
                    variant="contained"
                    sx={{
                        padding: "5px 28px",
                        width: "fit-content",
                        fontSize: "1rem",
                        backgroundColor: "#ffc845",
                        color: "black",
                        fontWeight: "bold",
                        borderRadius: "10px",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                        transition: "0.3s ease",
                        '&:hover': {
                            backgroundColor: "#e9b53dff",
                            transform: "scale(1.05)",
                        },
                    }}
                    onClick={() => navigate("../Dashboard")}
                >
                    Ir para a Plataforma Clarea Vital
                </Button>
            </div>
        </>
    );
};



export default ApresentacaoClarea;
